import { get } from 'lodash'
import { useQuery } from 'react-query'
import { AxiosError } from 'axios'

import { fetchAPI } from '@/lib/api'

import { ToshiOsAddPointsLog } from '../types'
import { Meta } from '@/features/filters/types'

import { TOSHI_OS_ADD_POINTS_LOGS } from '../constants'

type ToshiOsAddPointsLogResponse = {
  data: ToshiOsAddPointsLog[]
  meta: Meta
}

const getToshiOsAddPointsLogs = async (params: Meta): Promise<ToshiOsAddPointsLogResponse> => {
  const response = await fetchAPI({
    path: `/toshi_os_add_points_logs`,
    params,
  })
  const data = get(response, 'data.toshi_os_add_points_logs', [])
  const meta = get(response, 'data.meta', {})

  return { data, meta }
}

export const useToshiOsAddPointsLogs = ({
  params = {},
  initialData,
}: {
  params?: Meta
  initialData?: ToshiOsAddPointsLogResponse
}) => {
  return useQuery<ToshiOsAddPointsLogResponse, AxiosError>({
    queryKey: [TOSHI_OS_ADD_POINTS_LOGS, params],
    queryFn: () => getToshiOsAddPointsLogs(params),
    keepPreviousData: true,
    initialData,
  })
}
